/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CabinClass,
    CabinClassFromJSON,
    CabinClassFromJSONTyped,
    CabinClassToJSON,
} from './';

/**
 * 
 * @export
 * @interface CabinClassTTLOCriteriaOutput
 */
export interface CabinClassTTLOCriteriaOutput {
    /**
     * 
     * @type {boolean}
     * @memberof CabinClassTTLOCriteriaOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {CabinClass}
     * @memberof CabinClassTTLOCriteriaOutput
     */
    value?: CabinClass;
}

export function CabinClassTTLOCriteriaOutputFromJSON(json: any): CabinClassTTLOCriteriaOutput {
    return CabinClassTTLOCriteriaOutputFromJSONTyped(json, false);
}

export function CabinClassTTLOCriteriaOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinClassTTLOCriteriaOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : CabinClassFromJSON(json['value']),
    };
}

export function CabinClassTTLOCriteriaOutputToJSON(value?: CabinClassTTLOCriteriaOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': CabinClassToJSON(value.value),
    };
}


